<template>
  <button
      @click="$emit('click', $event)"
      data-dusk="sub-tab"
      :class="['sub-tab', 'transition-fast', small && 'small']"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "SubTabs.vue",
  props:{
    small: {
      type: Boolean
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.sub-tab {
  background-color: white;
  border-radius: $border-radius-base;
  box-shadow: $shadow-sm;
  border: 0;
  padding: $spacing-xs $spacing-xl;
  color: $brand-primary;
  font-size: $font-size-small;

  &.small {
    padding: $spacing-xs $spacing-md;
    height: $spacing-xxl;
  }
  &.active {
    color: white;
    background-color: $brand-primary;
  }
  &:hover {
    box-shadow: $shadow-md;
  }
}

.sub-tab-group.vertical {
  .sub-tab {
    text-align: right;
  }
}
</style>
